export default __webpack_public_path__ + "static/media/luminaborder.6f547f5a.png";